{
  "name": "gopr-inventory",
  "version": "1.1.6",
  "main": "expo-router/entry",
  "scripts": {
    "start": "expo start",
    "android": "expo start --android",
    "ios": "expo start --ios",
    "web": "expo start --web",
    "lint": "npx expo lint",
    "export:web": "node scripts/export-web.cjs",
    "export:web:sourcemaps": "node scripts/export-web.cjs --source-maps",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage"
  },
  "dependencies": {
    "@expo/vector-icons": "^15.1.1",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-community/datetimepicker": "^8.3.0",
    "@react-native-firebase/app": "^24.0.0",
    "@react-native-firebase/messaging": "24.0.0",
    "@react-native-google-signin/google-signin": "^16.1.2",
    "@react-navigation/drawer": "^7.5.7",
    "@sentry/react-native": "~7.2.0",
    "expo": "~54.0.33",
    "expo-asset": "^12.0.13",
    "expo-auth-session": "~7.0.11",
    "expo-constants": "~18.0.13",
    "expo-linking": "~8.0.12",
    "expo-notifications": "~0.32.17",
    "expo-font": "~14.0.11",
    "expo-router": "~6.0.23",
    "expo-splash-screen": "~31.0.13",
    "expo-status-bar": "~3.0.9",
    "expo-web-browser": "~15.0.11",
    "firebase": "^12.12.1",
    "react": "19.1.0",
    "react-dom": "^19.1.0",
    "react-native": "0.81.5",
    "react-native-gesture-handler": "^2.31.1",
    "react-native-reanimated": "^4.3.0",
    "react-native-safe-area-context": "^5.4.0",
    "react-native-screens": "~4.16.0",
    "react-native-web": "^0.21.0",
    "react-native-worklets": "^0.8.1"
  },
  "devDependencies": {
    "@types/react": "~19.1.0",
    "@types/react-native": "^0.72.8",
    "cpx2": "^8.0.0",
    "eas-cli": "^16.17.4",
    "eslint": "^9.39.4",
    "eslint-config-expo": "^55.0.0",
    "jest": "^30.1.3",
    "jest-environment-node": "^30.1.2",
    "jest-expo": "^54.0.11",
    "react-test-renderer": "19.1.0",
    "ts-jest": "^29.4.2",
    "typescript": "~5.9.2"
  },
  "private": true
}
